export default __webpack_public_path__ + "static/media/HomeServicesTransfer.61c5d8af.png";